import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { occupySeat } from '@reducers/checks';
import {
  pushMenuItemsByScreenId,
  setPosition,
  addChecks,
  replaceCart,
  updateSeatInfo,
  onSearchItem,
  updateCheckName,
  checkVoid,
  clearCart,
  setSeat,
  seatClear,
  searchString,
} from '@reducers/orders';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import Loader from '@components/common/Loader/newLoaderModal';
import { useOrderMenuTop } from './hooks/useOrderMenuTop';
import ServerAppScreen from './components/ServerAppScreen';
import CancelOrderModal from './components/CancelOrderModal';

const OrderMenuTopScreen = props => {
  const logic = useOrderMenuTop(props);
  const constructedProps = { ...props, ...logic };

  return (
    <div style={{ width: '85%', height: '100%', display: 'flex', alignItems: 'center', margin: 0, padding: 0 }}>
      {(logic.loader || props.loading) && (
        <Loader message={logic.loader ? 'Updating item' : ''} />
      )}
      {logic.isServerApp && <ServerAppScreen {...constructedProps} />}
      <CancelOrderModal {...constructedProps} />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.orders.loading || state.checks.loading,
  check: state.orders.seats,
  position: state.orders.position,
  deviceInfo: state.oauth.deviceInformation,
  auth: state.oauth.authInfo,
  userInfo: state.oauth.loggedInUserData,
  cart: state.orders.cart,
  serverAppTheme: state.theme.serverAppTheme,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      pushMenuItemsByScreenId,
      setPosition,
      updateChecksAfterResponse,
      replaceCart,
      updateSeatInfo,
      addChecks,
      onSearchItem,
      updateCheckName,
      setNotification,
      occupySeat,
      checkVoid,
      clearCart,
      seatClear,
      setSeat,
      searchString,
      setErrorPopUp,
    },
    dispatch
  );

const MemoizedOrderMenuTop = React.memo(OrderMenuTopScreen);
export default connect(mapStateToProps, mapDispatchToProps)(MemoizedOrderMenuTop);
